import request from '@/api/request.js'

// 新增
export function UserVSQuestionInsert(data) {
    return request({
        url: '/api/user/uservsquestioninsert',
        method: 'post',
        data: data
    })
}

// 新增
export function UserVSQuestionInsertMany(data) {
    return request({
        url: '/api/user/uservsquestioninsertmany',
        method: 'post',
        data: data
    })
}

// 删除
export function UserVSQuestionDelete(id) {
    return request({
        url: `/api/user/uservsquestiondelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function UserVSQuestionUpdate(id, data) {
    return request({
        url: `/api/user/uservsquestionupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function UserVSQuestionGetById(id) {
    return request({
        url: `/api/user/getuservsquestionbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function UserVSQuestionGetList(params) {
    return request({
        url: '/api/user/getuservsquestionlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function UserVSQuestionGetPageList(params) {
    return request({
        url: '/api/user/getuservsquestionpagelist',
        method: 'get',
        params: params
    })
}